// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {routerActions} from 'react-router-redux';

export const updateSearchQueryString = query => ({
    query,
    type: actions.UPDATE_RGA_SEARCH_QUERY_STRING
});

export const updateSearchByDropDown = key => ({
    key,
    type: actions.UPDATE_RGA_SEARCH_BY
});

export const onSearch = () =>
    dispatch => {

        dispatch(routerActions.push('/rga/results'));

    };

export const onSearchMassUpdate = () =>
        dispatch => {

            dispatch(routerActions.push('/rga/results/mass-update?massUpdate=true'));

        };
export const openMassUpdateModal = () =>
        dispatch => {

            dispatch(routerActions.push('/rga/mass-update'));

        };

export const openMassUploadModal = () =>
            dispatch => {

                dispatch(routerActions.push('/rga/mass-upload'));

            };



// WEBPACK FOOTER //
// ./src/rga/search/action-creators/search.js